import React from "react"
import { Stack } from "@mui/material"
import Button from "./Button"
import Text from "./Text"
import { formatNumber } from "src/utils/parseStringToBigNumber"
import { FER, USDC } from "src/constants"
import { getAddress } from "src/utils/addressHelpers"
import { useSelector } from "react-redux"
import { AppState } from "src/state"

const FerroBuyAction = () => {
  const price = useSelector(
    (state: AppState) => state.application.ferro?.price ?? 0,
  )

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <img src={FER.icon} width={20} />
      <Text>{formatNumber(price, 2, 6)}</Text>
      <a
        href={`https://vvs.finance/swap?disableCurrencySelect&inputCurrency=${getAddress(
          USDC.addresses,
        )}&outputCurrency=${getAddress(FER.addresses)}`}
        target="_blank"
        rel="noreferrer"
        style={{ textDecoration: "none" }}
      >
        <Button size="small" kind="outline">
          Buy
        </Button>
      </a>
    </Stack>
  )
}

export default FerroBuyAction
